export default {
  title: 'Comenzi ratate',
  card_title: 'E-mailuri pentru comenzi ratate',
  intro:
    'Dacă nimeni nu acceptă o comandă în {{minutes}} minute, aceasta este respinsă automat. Toți cei din această listă primesc apoi un e-mail cu comanda, ca cineva să poată interveni.',
  default: {
    owner: 'Proprietarul restaurantului',
    partner: 'Partener',
    owner_missing: 'Proprietarul restaurantului ({{email}}) nu va primi aceste e-mailuri.',
    partner_missing: 'Adresa implicită a partenerului ({{email}}) nu va primi aceste e-mailuri.',
  },
  empty: 'Nimeni nu ar afla despre comenzile ratate. Adaugă cel puțin un e-mail pentru a salva.',
  save_error: 'Nu s-au putut salva e-mailurile. Verifică conexiunea și încearcă din nou.',
  load_error: 'Nu s-au putut încărca e-mailurile. Verifică conexiunea și încearcă din nou.',
  unavailable: 'E-mailurile pentru comenzi ratate nu sunt disponibile pentru acest restaurant.',
  buttons: {
    save: 'Salvează',
    retry: 'Încearcă din nou',
  },
  toasts: {
    saved: 'E-mailurile pentru comenzi ratate au fost salvate',
  },
};
